export const environment = {
  production: true,
  apiUrl: 'https://api.clouddimension.in:8383/',
  authTokenEndpoint: 'https://api.clouddimension.in:8383/oauth/token',
  userinfoEndpoint: 'https://api.clouddimension.in:8383/user',
  clientId: 'onlinetdb',
  googleClientID: '437705264213-2tntf0t9lbajeihfo1t9qi12tc1h9vob.apps.googleusercontent.com',
  fbClientID: '1175423945893534',
  razorpayApiKey: 'rzp_live_zImOZNwUl1x0xy',
  facebookAppId: '415082972544993',
  googleOAuthClientId: '952298093688-ukdtmoilmhhg9i8cer4dfnihkjg8tb01.apps.googleusercontent.com',
  firebase: {
    // projectId: 'shivam-5f221',
    // appId: '1:952298093688:web:b9a4e8d8b8f9edce3a818d',
    // databaseURL: 'https://shivam-5f221.firebaseio.com',
    // storageBucket: 'shivam-5f221.appspot.com',
    // apiKey: 'AIzaSyAbtEinhC19FR1mLv17DLAH66LG5RDjX6E',
    // authDomain: 'shivam-5f221.firebaseapp.com',
    // messagingSenderId: '952298093688',
    // measurementId: 'G-GFJRGGE4Z7'
    apiKey: "AIzaSyAv0Ajt8VIKdO5iAfTlX0Q4gTWmr8t-3i8",
    authDomain: "pooja-booking-78a5b.firebaseapp.com",
    projectId: "pooja-booking-78a5b",
    storageBucket: "pooja-booking-78a5b.firebasestorage.app",
    messagingSenderId: "139298552977",
    appId: "1:139298552977:web:a863adc9161b393c755330",
    measurementId: "G-HTGMYKF3X8"
  },
  phoneVerificationFirebase: {
    // projectId: 'shivam-5f221',
    // appId: '1:952298093688:web:b9a4e8d8b8f9edce3a818d',
    // databaseURL: 'https://shivam-5f221.firebaseio.com',
    // storageBucket: 'shivam-5f221.appspot.com',
    // apiKey: 'AIzaSyAbtEinhC19FR1mLv17DLAH66LG5RDjX6E',
    // authDomain: 'shivam-5f221.firebaseapp.com',
    // messagingSenderId: '952298093688',
    // measurementId: 'G-GFJRGGE4Z7'
    apiKey: "AIzaSyAv0Ajt8VIKdO5iAfTlX0Q4gTWmr8t-3i8",
    authDomain: "pooja-booking-78a5b.firebaseapp.com",
    projectId: "pooja-booking-78a5b",
    storageBucket: "pooja-booking-78a5b.firebasestorage.app",
    messagingSenderId: "139298552977",
    appId: "1:139298552977:web:a863adc9161b393c755330",
    measurementId: "G-HTGMYKF3X8"
  }
};
